// extracted by mini-css-extract-plugin
export var infoRow = "_to-2";
export var labelContainer = "_to-0";
export var rightInfo = "_to-1";